import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";

/** Esiti dal peggiore al migliore: l'ordine è quello in cui vanno guardati. */
export type EsitoDomanda =
  | "mai_partita"
  | "non_recapitata"
  | "in_attesa"
  | "non_capita"
  | "chiusa_a_mano"
  | "risolta";

export interface DomandaRiga {
  id: string;
  tipo: string;
  tipo_label: string;
  esito: EsitoDomanda;
  esito_label: string;
  chiesta_il: string | null;
  riferimento: string | null;
  cliente: string | null;
  testo: string | null;
  campi: string[];
  n_opzioni: number;
  canale: string | null;
  destinatari: string[];
  stato_invio: string | null;
  in_riepilogo: boolean;
  sollecitata_il: string | null;
  n_tentativi: number;
  risolta_il: string | null;
  ore_per_risposta: number | null;
  aperta_da_ore: number | null;
}

export interface TotaliDomande {
  totale: number;
  per_esito: Record<EsitoDomanda, number>;
  percentuale_risposte: number;
  mediana_ore_risposta: number | null;
}

export interface DomandeResponse {
  totali: TotaliDomande;
  domande: DomandaRiga[];
}

export interface TentativoRisposta {
  il: string;
  canale: string;
  autore: string | null;
  testo: string | null;
  capita: boolean;
  interpretazione: string | null;
  motivo: string | null;
}

export interface DomandaDettaglio extends Omit<DomandaRiga, "n_opzioni"> {
  opzioni: { indice?: number; riferimento?: string; fatto?: string }[];
  domanda: {
    inviata_il: string | null;
    destinatari: string[];
    subject: string | null;
    corpo: string | null;
    stato_invio: string | null;
    errore: string | null;
  } | null;
  tentativi: TentativoRisposta[];
  esito_registrato: Record<string, unknown> | null;
}

export function useAgenteDomande(slug: string | undefined, esito?: string) {
  const qs = esito ? `?esito=${encodeURIComponent(esito)}` : "";
  return useQuery({
    queryKey: ["admin", "agente", slug, "domande", esito ?? ""],
    queryFn: () => apiFetch<DomandeResponse>(`/api/v1/admin/agenti/${slug}/domande${qs}`),
    enabled: !!slug,
  });
}

export function useAgenteDomanda(slug: string | undefined, id: string | null) {
  return useQuery({
    queryKey: ["admin", "agente", slug, "domanda", id],
    queryFn: () => apiFetch<DomandaDettaglio>(`/api/v1/admin/agenti/${slug}/domande/${id}`),
    enabled: !!slug && !!id,
  });
}
